import { Box, Button, Grid2 as Grid, styled } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  backgroundColor: '#f9fdfe',
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
}));

const DateRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
});

const SpacedContainer = styled(Grid)({ padding: '1rem' });

const Wrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

const FooterBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '2rem',
});

const RoleBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: 'fit-content',
});

const AvatarRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginTop: '0.5rem',
});

const OverlayContainer = styled(Box)({
  position: 'relative',
});

const BlurOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  backdropFilter: 'blur(4px)',
  borderRadius: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  zIndex: 10,
}));

const CreateModelSupportButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  padding: theme.spacing(1.5, 3),
  borderRadius: theme.spacing(1),
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const BlurredContent = styled(Box, {
  shouldForwardProp: prop => prop !== 'hasModelSupport',
})<{ hasModelSupport?: boolean }>(({ hasModelSupport }) => ({
  filter: hasModelSupport === false ? 'blur(2px)' : 'none',
  pointerEvents: hasModelSupport === false ? 'none' : 'auto',
}));

export { 
  AvatarRow, 
  Container, 
  DateRow, 
  FooterBox, 
  RoleBox, 
  SpacedContainer, 
  Wrapper,
  OverlayContainer,
  BlurOverlay,
  CreateModelSupportButton,
  BlurredContent
};
